import { Component, Input, OnInit } from '@angular/core';
import IPatient from '../../../_interfaces/IPatients';
import { BaseComponent } from '../../base/base.component';
import { SessionService } from '../../../_services/session/session.service';
import { RouterModule } from '@angular/router';

type PatientLinkValue = Partial<IPatient> & {
  id?: number | string;
  patients_id?: number | string;
  patient_id?: number | string;
  fullName?: string;
};

@Component({
  standalone: true,
  selector: 'app-patient-link',
  templateUrl: './patient-link.component.html',
  styleUrls: ['./patient-link.component.scss'],
  imports: [RouterModule],
})
export class PatientLinkComponent extends BaseComponent implements OnInit {
  @Input('patient') patient: PatientLinkValue | null = null;

  constructor(public session: SessionService) {
    super(session);
  }

  public getPatientRecordPage() {
    const customerIdentifier =
      this.customer?.identifier ||
      this.customer?.id ||
      this.session.getCustomer()?.identifier ||
      this.session.getCustomer()?.id;
    const patientId =
      this.patient?.id || this.patient?.patients_id || this.patient?.patient_id;
    return customerIdentifier && patientId
      ? `/${customerIdentifier}/patients/${patientId}/details`
      : null;
  }

  public getPatientName(): string {
    if (!this.patient) return '-';
    if (this.patient.fullName && typeof this.patient.fullName === 'string') {
      return this.patient.fullName;
    }
    const name = this.patient.name || '';
    const surname = this.patient.surname || '';
    return `${name} ${surname}`.trim() || '-';
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.patient?.name) {
      this.patient.fullName = `${this.patient.name || ''} ${
        this.patient.surname ? this.patient.surname : ''
      }`.trim();
    }
  }
}
